import { gql } from '@apollo/client';

export const CREATE_BADGE_ASSIGNMENT = gql`
	mutation CreateBadgeAssignment($input: CreateBadgeAssignmentInput!) {
		createBadgeAssignment(input: $input) {
			id
			badgeId
			userId
			awardedBy
			awardedByUser {
				id
				firstName
				lastName
				avatar {
					bucket
					key
					region
				}
				departmentId
				userGroupId
				subCompanyId
			}
			companyId
			content {
				message
				gifURL
				tags
			}
			createdAt
			updatedAt
			isPrivate
			approvalStatus
			quietDecline
			additionalRecipients
			additionalRecipientsUsers {
				id
				firstName
				lastName
				departmentId
				subCompanyId
				userGroupId
			}
			recipients {
				accountClaimId
				accountClaim {
					id
					firstName
					lastName
					emailAddress
					subCompany
					department
					employeeId
					userId
				}
				userId
				user {
					id
					firstName
					lastName
					departmentId
					subCompanyId
					userGroupId
				}
			}
			points
			user {
				id
				firstName
				lastName
				departmentId
				subCompanyId
				userGroupId
				avatar {
					key
					bucket
					region
				}
			}
			badge {
				id
				name
				description
				points
			}
		}
	}
`;

export const UPDATE_BADGE_ASSIGNMENT = gql`
	mutation UpdateBadgeAssignment($input: UpdateBadgeAssignmentInput!) {
		updateBadgeAssignment(input: $input) {
			id
			accountClaimId
			accountClaim {
				id
				firstName
				lastName
				emailAddress
				subCompany
				department
				employeeId
				userId
			}
			badgeId
			badge {
				id
				name
				badgeType {
					code
				}
				badgeTypeId
				color
				description
				gradientColor
				iconId
				icon {
					code
				}
				image
				label
				isAssignmentRestricted
				shape
				category
			}
			awardedBy
			awardedByUser {
				id
				firstName
				lastName
				avatar {
					bucket
					key
					region
				}
				departmentId
				userGroupId
				subCompanyId
			}
			companyId
			createdAt
			approvalStatus
			quietDecline
			additionalRecipients
			additionalRecipientsUsers {
				id
				firstName
				lastName
				departmentId
				subCompanyId
			}
			isPrivate
			rewardBonus
			points
			comments
			totalClaps
			hasClappedUsers {
				id
				firstName
				lastName
			}
			content {
				message
				gifURL
				tags
			}
			userId
			user {
				id
				firstName
				lastName
				departmentId
				subCompanyId
				avatar {
					key
					bucket
					region
				}
			}
		}
	}
`;

export const ADD_REMOVE_CLAP = gql`
	mutation AddRemoveClap($badgeAssignmentId: ID!, $userId: ID!) {
		addRemoveClap(badgeAssignmentId: $badgeAssignmentId, userId: $userId) {
			id
			accountClaimId
			accountClaim {
				id
				firstName
				lastName
				emailAddress
				subCompany
				department
				employeeId
				userId
			}
			badgeId
			badge {
				id
				name
				badgeType {
					code
				}
				badgeTypeId
				color
				description
				gradientColor
				iconId
				icon {
					code
				}
				image
				label
				isAssignmentRestricted
				shape
				category
			}
			awardedBy
			awardedByUser {
				id
				firstName
				lastName
				avatar {
					bucket
					key
					region
				}
				departmentId
				userGroupId
				subCompanyId
			}
			companyId
			createdAt
			isPrivate
			approvalStatus
			quietDecline
			additionalRecipients
			additionalRecipientsUsers {
				id
				firstName
				lastName
				departmentId
				subCompanyId
			}
			rewardBonus
			points
			comments
			totalClaps
			hasClappedUsers {
				id
				firstName
				lastName
			}
			content {
				message
				gifURL
				tags
			}
			userId
			user {
				id
				firstName
				lastName
				departmentId
				subCompanyId
				avatar {
					key
					bucket
					region
				}
			}
		}
	}
`;

export const GENERATE_CERTIFICATE = gql`
	mutation GenerateCertificate(
		$badgeAssignmentId: ID!
		$fieldValues: [CertificateFieldValueInput]
	) {
		generateCertificate(
			badgeAssignmentId: $badgeAssignmentId
			fieldValues: $fieldValues
		) {
			exportKey
		}
	}
`;

export const UPDATE_USER_RECOGNITION_EVENTS = gql`
	mutation UpdateUser($input: UpdateUserInput!) {
		updateUser(input: $input) {
			id
			recognitionEvents {
				currentBudget
				amountPending
				additionalBudgetTotal
				lastUpdated
				hasSeenPopup
				eventList {
					adminOverride
					approvalResult
					budgetAfterTotal
					budgetBeforeTotal
					completedById
					completedDate
					createdDate
					pendingApproval
					recognitionAmount
					recognitionId
					recognitionName
					sentById
					sentByManager
					sentReason
					snappyCampaignTierId
					snappyGrantId
				}
			}
		}
	}
`;
